module.exports = __webpack_public_path__ + "img/education.60998d63.png";